import React, { useEffect, Fragment} from 'react'
import { useGlobal } from "reactn";
import 'leaflet/dist/leaflet.css';
import HeaderBar from '../../../components/atoms/headerBar/HeaderBar';
import GridBackground from '../../molecules/gridBackround/GridBackground'
import styles from './Tutorial.module.scss'
import ReactPlayer from "react-player"

// Path to images used in the HTML
// import ImgOverview from '../../../assets/img/tutorial/overview.png'

const Tutorial = () => {

  const [, setshowDataLookup] = useGlobal('showDataLookup')

  // eslint-disable-next-line
  useEffect(() => { setshowDataLookup([])}, [])

  return (
    <Fragment>
      <div className="NavContainer">
        <HeaderBar />
      </div>
      <div className={styles.outer}>
      <div className={styles.content}>
        <GridBackground>
          <div className={styles.pageContent}>
          <h1>Tutorial</h1>
          
          <p>Coming soon: video demo of the app, along with instructions on how to use the tool to help determine suitable sites for new schools.</p>
          <ReactPlayer
            url="https://youtu.be/NpEaa2P7qZI"
          />
          </div>
        </GridBackground>
      </div>
      </div>
    </Fragment>
  );
}

export default Tutorial

